import { styled, component } from '../../../utils/style';
import { StyleColor } from '../../../utils/styles-constants';

export const StyledMultiAppAuthenticationPopup = styled()(component.div, 'StyledMultiAppAuthenticationPopup') `
	position: fixed;
	left: 50%;
	top: 50%;
	z-index: 11;
	background: ${StyleColor.White};
	padding: 60px 40px;
	transform: translate(-50%, -50%);
	width: 90%;
	max-width: 400px;
	box-sizing: border-box;
	align-items: center;
	display: flex;
	flex-direction: column;
`;

export const CloseButton = styled()(component.div, 'CloseButton') `
	position: absolute;
	right: 10px;
	top: 10px;
	cursor: pointer;

	> svg {
		width: 30px;
		height: 30px;
		fill: ${StyleColor.Grey500};
	}
`;

export const AccessibleAppSelectWrapper = styled()(component.div, 'AccessibleAppSelectWrapper') `
	width: 100%;
	margin-bottom: 15px;
	position: relative;
`;

export const AccessibleAppSelect = styled()(component.select, 'AccessibleAppSelect') `
	width: 100%;
	border: 1px solid ${StyleColor.Grey400};
	height: 40px;
	color: ${StyleColor.Grey500};
	background: ${StyleColor.White};
	padding: 0 15px;
	-webkit-appearance: none;
	-moz-appearance: none;
	outline: none;
`;

export const AccessibleAppSelectIcon = styled()(component.div, 'AccessibleAppSelectIcon') `
	position: absolute;
	top: 7.5px;
	right: 7.5px;
	pointer-events: none;

	> svg {
		width: 25px;
		height: 25px;
		fill: ${StyleColor.Grey500};
	}
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/MultiAppAuthentication/Popup/styles.ts